export const infoTitleMessage = {
	member_id: "Please contact your administrator for changing Employee ID!",
	first_name: "Please contact your administrator for changing First Name!",
	last_name: "Please contact your administrator for changing Last Name!",
	email: "Please contact your administrator for changing Email!",
	employee_number: "Please contact your administrator for updating WLT Employee Number!",
	SSN: "Please contact your administrator for changing SSN!",
	hire_date: "Please contact your administrator for changing Hire Date!",
	upload_type: "Please contact your administrator for changing the Upload Type!",
	country: "Please contact your administrator for changing the Country!",
	dependent_number: "Please contact your administrator for updating WLT Dependent Number!",
	dependent_status: "Please contact your administrator for updating Dependent Status!",
	group: "Please contact your administrator for changing the Group!",
	location: "Please contact your administrator for changing the Location!",
	paycheck_start_date: "Paycheck Start Date will be same as Hire Date!",
	employment_paycheck_start_date: "Paycheck Start Date will be same as Employment Start Date!",
	employment_start_date: "Employment Start Date will be same as Hire Date!",
	paycheck_employment_start_date: "Employment Start Date is Non-Editable!",
	paycheck_employee_class: "Employee Class is Non-Editable!"
};
